import React, {useState} from "react";
import {
    closePopupModal,
    endAnimation,
    isAnimationFinishedSelector,
    isPopupModalOpenSelector,
    openedPopupModalSelector,
    PopupModalName,
    popupModalPropsSelector
} from "./popupModalSlice";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";

import styles from "./PopupModalProvider.module.css"
import classnames from "classnames";
import {
    ReimportVehiclesConfirmationModal
} from "./impl/reimportVehiclesConfirmationModal/ReimportVehiclesConfirmationModal";
import {DeleteBotConfirmationModal} from "./impl/deleteBotConfirmationModal/DeleteBotConfirmationModal";
import {DeleteLocationConfirmationModal} from "./impl/deleteLocationConfirmationModal/DeleteLocationConfirmationModal";
import {DeleteFranchiseConfirmationModal} from "./impl/deleteFranchiseConfirmationModal/DeleteFranchiseConfirmationModal";
import {ViewMoreModal} from "./impl/viewMoreModal/ViewMoreModal";
import {UnsavedChangesConfirmationModal} from "../unsavedChangesConfirmationModal/UnsavedChangesConfirmationModal";
import {
    DeleteIntegrationConfirmationModal
} from "./impl/deleteIntegrationConfirmationModal/DeleteIntegrationConfirmationModal";
import {
    OfferStatusChangeConfirmationModal
} from "./impl/offerStatusChangeConfirmationModal/OfferStatusChangeConfirmationModal";
import {SaveNewOffersConfirmationModal} from "./impl/saveNewOffersConfirmationModal/SaveNewOffersConfirmationModal";
import {ConfigurationIssuesModal} from "./impl/configurationIssuesModal/ConfigurationIssuesModal";
import {
    DeleteKnowledgeRecordConfirmationModal
} from "./impl/deleteKnowledgeRecordConfirmationModal/DeleteKnowledgeRecordConfirmationModal";
import {RoutingDecisionModal} from "./impl/routingDecisionModal/RoutingDecisionModal";
import {
    DeleteKnowledgeDefinitionConfirmationModal
} from "./impl/deleteKnowledgeDefinitionConfirmationModal/DeleteKnowledgeDefinitionConfirmationModal";
import {ImportAssistantModal} from "./impl/importAssistantModal/ImportAssistantModal";
import {CloneAssistantModal} from "./impl/cloneAssistantModal/CloneAssistantModal";

interface PopupModalProviderProps {
    children: any
}

export const PopupModalProvider: React.FC<PopupModalProviderProps> = ({
                                                                          children
                                                                      }) => {

    const dispatch = useAppDispatch()
    const [isInsideModal, setIsInsideModal] = useState(false);
    const popupModalProps = useAppSelector(popupModalPropsSelector);
    const isPopupModalOpen = useAppSelector(isPopupModalOpenSelector);
    const isAnimationFinished = useAppSelector(isAnimationFinishedSelector);
    const openedPopupModal = useAppSelector(openedPopupModalSelector);

    const handleClick = () => {
        if (isPopupModalOpen) {
            dispatch(closePopupModal())
            setTimeout(() => {
                dispatch(endAnimation())
            }, 500)
        }
    }

    const openPopupModalMap: Partial<Record<PopupModalName, JSX.Element>> = {}

    openPopupModalMap[PopupModalName.IMPORT_ASSISTANT] = <ImportAssistantModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.CLONE_ASSISTANT] = <CloneAssistantModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.DELETE_BOT] = <DeleteBotConfirmationModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.DELETE_LOCATION] = <DeleteLocationConfirmationModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.DELETE_FRANCHISE] = <DeleteFranchiseConfirmationModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.VIEW_MORE] = <ViewMoreModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.REIMPORT_VEHICLES] = <ReimportVehiclesConfirmationModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.UNSAVED_CHANGES] = <UnsavedChangesConfirmationModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.DELETE_INTEGRATION] = <DeleteIntegrationConfirmationModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.CHANGE_OFFER_STATUS] = <OfferStatusChangeConfirmationModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.PREVIEW_OFFERS] = <SaveNewOffersConfirmationModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.CONFIGURATION_ISSUES] = <ConfigurationIssuesModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.DELETE_KNOWLEDGE_RECORD] = <DeleteKnowledgeRecordConfirmationModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.DELETE_KNOWLEDGE_DEFINITION] = <DeleteKnowledgeDefinitionConfirmationModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    openPopupModalMap[PopupModalName.VIEW_ROUTING_DECISION] = <RoutingDecisionModal
        handleClose={handleClick}
        {...popupModalProps}
    />

    const handleMouseDown = (e: React.MouseEvent) => {
        const target = e.target as HTMLElement;
        const isInsideModal = target.closest(`.${styles.modal}`) !== null
        setIsInsideModal(isInsideModal);
    };

    const handleMouseUp = (e: React.MouseEvent) => {
        if (!isInsideModal && isPopupModalOpen) {
            dispatch(closePopupModal());
            setTimeout(() => {
                dispatch(endAnimation());
            }, 500);
        }
    };

    return <div onMouseUp={handleMouseUp} onMouseDown={handleMouseDown}>
        {!(isAnimationFinished && !isPopupModalOpen) &&
            <div
                className={classnames(styles.modalWrapper, (!isPopupModalOpen && isAnimationFinished) && styles.modalClosed)}
                onClick={(e) => e.stopPropagation()}
            >
                {isPopupModalOpen && <div
                    className={styles.modal}
                    onClick={(e) => e.stopPropagation()}>
                    {openPopupModalMap[openedPopupModal!]}
                </div>}
            </div>
        }
        <div
            className={classnames(isPopupModalOpen ? styles.outsideModalOpen : styles.outsideModalClosed, (!isPopupModalOpen && isAnimationFinished) && styles.modalClosed)}/>
        {children}
    </div>
}
